module.exports = __webpack_public_path__ + "img/2021年度国民信赖十大健康品牌.d10a14b2.jpg";